module.exports = __webpack_public_path__ + "img/bessac_bg_04_.465acef6.jpg";